import api from "../utils/api";
import { GET_3D_MODEL_URL, GET_2D_MODEL_URL, GET_360VIEW_MODEL_URL, GET_SCAN_INFO, CLEAR_SCAN_INFO } from "./types";

const getContentTypeFromFileName = (fileName = "") => {
  const extension = fileName.split(".").pop()?.toLowerCase();

  const mimeByExtension = {
    pgm: "image/x-portable-graymap",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    webp: "image/webp",
    gif: "image/gif",
    svg: "image/svg+xml",
  };

  return mimeByExtension[extension] || "application/octet-stream";
};

export const get3DModelURL =
  ({ containerName, fileName, modelType = "3DModel" }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_3D_MODEL_URL,
        payload: { [modelType]: { loading: true } },
      });

      const { data } = await api.get(`/3dfusion/${containerName}/${fileName}`);

      dispatch({
        type: GET_3D_MODEL_URL,
        payload: {
          [modelType]: {
            loading: false,
            modelUrl: data.modelUrl,
            contentType: data.contentType,
          },
        },
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: GET_3D_MODEL_URL,
        payload: {
          [modelType]: {
            loading: false,
            modelUrl: null,
            contentType: null,
          },
        },
      });
    }
  };

export const get2DModelURL =
  ({ containerName, fileName, modelType }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_2D_MODEL_URL,
        payload: { [modelType]: { loading: true } },
      });

      dispatch({
        type: GET_2D_MODEL_URL,
        payload: {
          [modelType]: {
            loading: false,
            modelUrl: `api/3dfusion/file/${containerName}/${fileName}`,
            contentType: getContentTypeFromFileName(fileName),
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

export const get360ModelURL =
  ({ fileURL, modelType }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_360VIEW_MODEL_URL,
        payload: { [modelType]: { loading: true } },
      });

      dispatch({
        type: GET_360VIEW_MODEL_URL,
        payload: {
          [modelType]: {
            loading: false,
            modelUrl: fileURL,
            contentType: "object/360view",
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

export const getScanInfo = (floorID) => async (dispatch) => {
  try {
    dispatch({ type: GET_SCAN_INFO, payload: { scanInfo: { loading: true } } });

    const { data } = await api.get(`/3dfusion/scan/floor/${floorID}`);

    dispatch({
      type: GET_SCAN_INFO,
      payload: {
        scanInfo: {
          loading: false,
          data: data.data || [],
        },
      },
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: GET_SCAN_INFO,
      payload: {
        scanInfo: {
          loading: false,
          data: [],
        },
      },
    });
  }
};

export const addRoom = (roomData) => async (dispatch) => {
  try {
    const { data } = await api.post("/3dfusion/room", roomData);
    console.log("Room added successfully:", data);
    return data;
  } catch (error) {
    console.log("Error adding new scan:", error);
    throw error;
  }
};

export const getRoomsByFloor = (floorID, jobId) => async () => {
  try {
    const params = new URLSearchParams();
    if (jobId) {
      params.set("job_id", jobId);
    }

    const query = params.toString();
    const endpoint = query
      ? `/3dfusion/room/floor/${floorID}?${query}`
      : `/3dfusion/room/floor/${floorID}`;

    const { data } = await api.get(endpoint);
    return data?.data || [];
  } catch (error) {
    console.log("Error getting room data:", error);
    throw error;
  }
};

export const deleteRoomById = (roomId) => async () => {
  try {
    const { data } = await api.delete(`/3dfusion/room/${roomId}`);
    return data;
  } catch (error) {
    console.log("Error deleting room:", error);
    throw error;
  }
};

export const updateRoomById = (roomId, roomData) => async () => {
  try {
    const { data } = await api.put(`/3dfusion/room/${roomId}`, roomData);
    return data;
  } catch (error) {
    console.log("Error updating room:", error);
    throw error;
  }
};

export const clearScanInfo = () => (dispatch) => {
  dispatch({ type: CLEAR_SCAN_INFO });
};
